import React from 'react'
import type { Icon } from 'shared/utils'

const CircleAvatar = (props: Icon) => {
    const {
        color = 'white',
        background = '#A11A2C',
        size = 32,
        className = 'circle-avatar'
    } = props
    return (
        <svg width={size} height={size} className={className}>
            <g fill="none" fillRule="evenodd">
                <circle
                    cx={size / 2}
                    cy={size / 2}
                    r={size / 2}
                    fill={background}
                />
                <path
                    fill={color}
                    d="M15.742 13.859c1.797-.595 2.782-1.276 3.185-1.768a4.346 4.346 0 0 1 .42 6.869 4.329 4.329 0 0 1-5.726 0 4.336 4.336 0 0 1-1.285-4.58c.659.1 1.788.015 3.406-.521zm-5.41-4.253l.048.148a.726.726 0 0 1-.176-1.411.725.725 0 1 1 .377 1.397l2.567.814c.016-.016.29-.662.825-1.938a.784.784 0 1 1 .335-.11l-.057-.058c.028.029.052.053.057.06 1.598.485 2.426.732 2.486.739l.903-1.864a.724.724 0 1 1 .17-.11 10.823 10.823 0 0 1-.001.004l1.068 3.223c.04.12-.023.307-.208.533-.403.493-1.388 1.174-3.185 1.769-1.618.536-2.747.622-3.406.52-.409-.063-.637-.197-.687-.343l-1.067-3.223c.03.001.06-.005.09-.007-.03.002-.06.008-.09.005l-.05-.148s-.014-.052.001-.067c-.015.015 0 .067 0 .067zm9.016 10.478A7.486 7.486 0 0 1 23.968 27H9a7.486 7.486 0 0 1 4.62-6.916 4.33 4.33 0 0 0 5.728 0z"
                />
            </g>
        </svg>
    )
}

export { CircleAvatar }
